// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"370":"97d6eb51b2357c90","502":"79391be70e878e8d"}[chunkId] + ".css";
};